import ImageList from "@mui/material/ImageList";
import ImageListItem from "@mui/material/ImageListItem";
import "react-photo-view/dist/react-photo-view.css";
import { PhotoProvider, PhotoView } from "react-photo-view";
import { API_MEDIA } from "../../env";
import "./list_foto.scss";

export default function StandardImageList({ image_list, title }) {
  return (
    <PhotoProvider className="custom-preview-container">
      <ImageList sx={{ width: "100%" }} cols={3}>
        {image_list.map((item) => (
          <PhotoView
            key={item.img}
            src={API_MEDIA + "/media/foto/" + title + "/big/" + item}
            // className="custom-preview"
          >
            <ImageListItem key={item.img}>
              <img
                // srcSet={`${API_MEDIA + "/media/foto/" + title + "/small/" + item}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                // src={`${API_MEDIA + "/media/foto/" + title + "/small/" + item}?w=164&h=164&fit=crop&auto=format`}
                srcSet={`${API_MEDIA + "/media/foto/" + title + "/small/" + item}?w=164&h=164&fit=crop&auto=format&dpr=2 2x`}
                src={`${API_MEDIA + "/media/foto/" + title + "/small/" + item}?w=164&h=164&fit=crop&auto=format`}
                alt={item.title}
                loading="lazy"
              />
            </ImageListItem>
          </PhotoView>
        ))}
      </ImageList>
    </PhotoProvider>
  );
}

// const itemData = [
//   {
//     img: "./1.jpg",
//     title: "Breakfast",
//   },
//   {
//     img: "./1.jpg",
//     title: "Burger",
//   },
//   {
//     img: "./1.jpg",
//     title: "Camera",
//   },
//   {
//     img: "./1.jpg",
//     title: "Coffee",
//   },
//   {
//     img: "./1.jpg",
//     title: "Hats",
//   },
//   {
//     img: "./1.jpg",
//     title: "Honey",
//   },
//   {
//     img: "./1.jpg",
//     title: "Basketball",
//   },
//   {
//     img: "./1.jpg",
//     title: "Fern",
//   },
//   {
//     img: "./1.jpg",
//     title: "Mushrooms",
//   },
//   {
//     img: "./1.jpg",
//     title: "Tomato basil",
//   },
//   {
//     img: "./1.jpg",
//     title: "Sea star",
//   },
//   {
//     img: "./1.jpg",
//     title: "Bike",
//   },
// ];
